/** @format */
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { OtmId } from 'common-typescript/types';
import { EMPTY, Observable, ReplaySubject, switchMap } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { LocaleService } from 'sis-common';
import { AppErrorHandler } from '../../error-handler/app-error-handler';
import { OrganisationSettingsService } from '../../service/organisation-settings.service';

@Component({
    selector: 'sis-graduation-instructions',
    standalone: false,
    templateUrl: './graduation-instructions.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GraduationInstructionsComponent implements OnInit {
    @Input() set organisationId(value: OtmId) {
        this.organisationIdInputSubject$.next(value);
    }

    organisationIdInputSubject$ = new ReplaySubject<OtmId>(1);

    localizedGraduationInstructionsUrl$: Observable<string>;

    constructor(
        private readonly organisationSettingsService: OrganisationSettingsService,
        private readonly localeService: LocaleService,
        private readonly appErrorHandler: AppErrorHandler,
    ) {}

    ngOnInit(): void {
        this.localizedGraduationInstructionsUrl$ = this.createLocalizedGraduationInstructionsUrlObservable(
            this.organisationIdInputSubject$,
        );
    }

    createLocalizedGraduationInstructionsUrlObservable(organisationId$: Observable<OtmId>): Observable<string> {
        return organisationId$.pipe(
            switchMap(organisationId => {
                if (organisationId) {
                    return this.organisationSettingsService
                        .getInheritedSettingsByOrganisationId(organisationId)
                        .pipe(take(1), this.appErrorHandler.defaultErrorHandler());
                }
                return EMPTY;
            }),
            map(organisationSettings => this.localeService.localize(organisationSettings.graduationInstructionsUrl)),
        );
    }
}
